__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-09-03-1788425036-stable-dev/";